import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { values } from 'lodash/fp';

import * as sellerTypes from 'constants/sellerType';

import AutoheroIcon from './svg/Autohero.com.svg';
import PrivateSaleIcon from './svg/PrivateSale.com.svg';

import cn from './styles.local.less';

export default class SellerBadge extends PureComponent {
  static propTypes = {
    sellerType: PropTypes.oneOf(values(sellerTypes)).isRequired,
  };

  render() {
    switch (this.props.sellerType) {
      case sellerTypes.RETAIL:
        return <AutoheroIcon className={cn.autohero} />;

      case sellerTypes.PRIVATE_SALE:
        return <PrivateSaleIcon className={cn.private} />;

      case sellerTypes.PRIVATE_LISTING_SELLER:
        return <div>{__('sellerType.privateListingSeller')}</div>;

      default:
        return null;
    }
  }
}
